import React from 'react';
import { Alert, Box, Chip, Typography } from '@mui/material';

interface SimilarAccountNameWarningProps {
    matches: SimilarAccountName[];
}

export type SimilarAccountName = {
    id: number;
    name: string;
    abbreviation: string;
    reason: string;
};

export function SimilarAccountNameWarning({
    matches,
}: SimilarAccountNameWarningProps) {
    if (matches.length === 0) return null;

    return (
        <Alert severity={'warning'} sx={{ mt: 1, alignItems: 'flex-start' }}>
            <Typography variant={'body2'}>
                Ya existe una cuenta activa con un nombre igual o parecido:
            </Typography>
            <Box component={'ul'} sx={{ my: 0.5, pl: 2.5 }}>
                {matches.map((match) => (
                    <li key={match.id}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.75,
                                flexWrap: 'wrap',
                            }}
                        >
                            <Chip
                                color={'warning'}
                                label={
                                    match.reason === 'normalized_exact'
                                        ? 'Nombre igual'
                                        : match.reason === 'partial'
                                        ? 'Coincidencia parcial'
                                        : 'Nombre parecido'
                                }
                                size={'small'}
                            />
                            <Typography variant={'body2'}>
                                {match.name}
                                {match.abbreviation
                                    ? ` (${match.abbreviation})`
                                    : ''}
                            </Typography>
                        </Box>
                    </li>
                ))}
            </Box>
            <Typography variant={'body2'}>
                Puedes guardar esta cuenta si realmente es distinta.
            </Typography>
        </Alert>
    );
}
